import {
  AllocationManualActionRequestModel,
  AllocationViewActionIdentifierModel,
  AllocationViewSelectedEntityModel,
} from '../../models';
import { NfStatus } from '../../../nota-fiscal/models/nf-status.enum';

export class AllocationViewCallToDockActionPrepare {
  public static readonly type = '[AllocationViewCallToDockAction] Call To Dock Prepare';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewCallToDockAction {
  public static readonly type = '[AllocationViewCallToDockAction] Call To Dock';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
      nfConsent?: boolean;
    },
  ) {}
}

export class AllocationViewCallToDockConsentRequired {
  public static readonly type = '[AllocationViewCallToDockAction] Consent Required';

  constructor(public nfStatus: NfStatus | null) {}
}

export class AllocationViewCallToDockDismissConsent {
  public static readonly type = '[AllocationViewCallToDockAction] Dismiss Consent';
}

export class AllocationViewCallToDockActionLoadAllocationDetails {
  public static readonly type = '[AllocationViewCallToDockAction] Load Allocation Details';

  constructor(public payload: AllocationViewSelectedEntityModel) {}
}

export class AllocationViewCallToDockActionAllocateUli {
  public static readonly type = '[AllocationViewCallToDockAction] Allocate ULI';

  constructor(public payload: AllocationManualActionRequestModel) {}
}

export class AllocationViewCallToDockActionSetInitialState {
  public static readonly type = '[AllocationViewCallToDockAction] Set Initial State';
}
